module.exports = __webpack_public_path__ + "media/components/Agencies/Layouts/SideMenu/influencersIcon-1d7bd5a13c43306688c6aef5f15d0745.svg";